import {Injectable} from "@angular/core";
import {ConfigService} from "./config.service";
import {HttpService} from "../../services/http.service";


@Injectable({
    providedIn: 'root'
})

export class DashboardService{

    constructor(private httpClient: HttpService, private configService: ConfigService) {
    }

    getDashboard(params?: {startDate?: string, endDate?: string}){
        return this.httpClient.get<any>(this.configService.dashboardUrl, { params });
    }

}
